module Meevo.Plugins.YieldManagementProgram {

    class SearchItemComponent implements ng.IComponentController {
        isExpanded: boolean;
        item: any;
    }


    angular.module('meevo.plugins.yieldManagementProgram')
        .component('ympSearchItem', {
            templateUrl: 'app/plugins/yieldManagementProgram/components/search-item/search-item.component.html',
            bindings: {
                item: '=',
                disableCrud: '=',
                add: '&',
                getAddSecurityKey: '&',
            },
            controller: SearchItemComponent
        });
}
